import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    width: 100%;
    padding: 24px 16px 40px 16px;
    flex-direction: column;
    @media (min-width: 800px) {
      padding: 16px 32px 48px 32px;
    }
  `,
  header: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0px;
  `,
  title: css`
    padding-bottom: 4px;
  `,
  titleContainer: css`
    text-align: center;
    padding-bottom: 16px;
  `,
  headerShrunk: css`
    display: flex;
    justify-content: center;
    padding: 16px 0px;
    -webkit-transition: height 0.2s;
    -moz-transition: height 0.2s;
    -ms-transition: height 0.2s;
    -o-transition: height 0.2s;
    transition: height 0.2s;
  `,
  logoTransition: css`
    -webkit-transition: height 0.2s;
    -moz-transition: height 0.2s;
    -ms-transition: height 0.2s;
    -o-transition: height 0.2s;
    transition: height 0.2s;
  `,
};

export default styles;
